import { makeObservable, observable } from 'mobx';
import { Notify } from '@shared/ui-native/Notify';
import axios from 'axios';


export class LoadMorePager<T> {
    page = -1;
    @observable isLoading = false;
    @observable hasLoadedEverything = false;

    constructor(
        private doFetch: (page: number, pageSize: number) => Promise<T[]>,
        public pageSize = 20
    ) {
        makeObservable(this);
    }

    loadMore = async (notifyEnd): Promise<T[]> => {
        if (this.isLoading) {
            return Promise.resolve([]);
        }

        return new Promise(async (done, fail) => {
            this.isLoading = true;
            try {
                this.page += 1;

                const items = await this.doFetch(this.page, this.pageSize);

                if (items.length < this.pageSize) {
                    this.hasLoadedEverything = true;
                    if (notifyEnd) {
                        Notify.success('No more items');
                    }
                }

                done(items);
            }
            catch (err) {
                if (err.data?.errorCode === 404 || err.response?.status === 404) { // backend is made to return 404 when list is empty
                    this.hasLoadedEverything = true;
                    if (notifyEnd) {
                        Notify.success('No more items');
                    }
                }
                else {
                    if (axios.isCancel(err)) {
                        fail({ message: 'canceled' });
                    } else {
                        this.page -= 1;
                        Notify.error('Error while loading');
                        fail();
                    }
                }
            }
            finally {
                this.isLoading = false;
            }
        });
    };

    reset = () => {
        this.page = -1;
        this.pageSize = 10;
        this.hasLoadedEverything = false;
    }
}
